export const PERSON_CREDIT_ROLES = ['actor', 'director', 'writer', 'musician', 'producer'] as const;

export type PersonCreditRoleType = (typeof PERSON_CREDIT_ROLES)[number];
